<script>
import {
  BaseLabelColor,
  BaseLabelShade,
} from '@/shared/constants/baseComponents/baseLabel'

export default {
  name: 'BaseLabel',
  props: {
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: BaseLabelColor.blue,
    },
    shade: {
      type: String,
      default: BaseLabelShade.inverted,
    },
  },
  computed: {
    labelStyle() {
      var color = Object.values(BaseLabelColor).includes(this.color)
        ? this.color
        : BaseLabelColor.blue
      var shade = Object.values(BaseLabelShade).includes(this.shade)
        ? this.shade
        : BaseLabelShade.inverted
      return `text-caption-bold base-label base-label-color-${color}-${shade}`
    },
  },
}
</script>

<template>
  <v-chip :class="labelStyle">
    {{ text }}
  </v-chip>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
.base-label {
  padding: 4px 12px !important;
  border-radius: 40px !important;
}

// BLUE
.base-label-color-blue-inverted {
  color: $color-white !important;
  background-color: $color-blue-400 !important;
  border-color: $color-blue-400 !important;
}
.base-label-color-blue-light {
  color: $color-blue-600 !important;
  background-color: $color-blue-200 !important;
  border-color: $color-blue-200 !important;
}
.base-label-color-blue-dark {
  color: $color-blue-600 !important;
  background-color: $color-blue-300 !important;
  border-color: $color-blue-300 !important;
}

// YELLOW
.base-label-color-yellow-inverted {
  color: $color-white !important;
  background-color: $color-warning-400 !important;
  border-color: $color-warning-400 !important;
}
.base-label-color-yellow-light {
  color: $color-warning-500 !important;
  background-color: $color-warning-200 !important;
  border-color: $color-warning-200 !important;
}
.base-label-color-yellow-dark {
  color: $color-warning-500 !important;
  background-color: $color-warning-300 !important;
  border-color: $color-warning-300 !important;
}

// RED
.base-label-color-red-inverted {
  color: $color-white !important;
  background-color: $color-error-400 !important;
  border-color: $color-error-400 !important;
}
.base-label-color-red-light {
  color: $color-error-500 !important;
  background-color: $color-error-200 !important;
  border-color: $color-error-200 !important;
}
.base-label-color-red-dark {
  color: $color-error-500 !important;
  background-color: $color-error-300 !important;
  border-color: $color-error-300 !important;
}

// GREEN
.base-label-color-green-inverted {
  color: $color-white !important;
  background-color: $color-success-400 !important;
  border-color: $color-success-400 !important;
}
.base-label-color-green-light {
  color: $color-success-500 !important;
  background-color: $color-success-200 !important;
  border-color: $color-success-200 !important;
}
.base-label-color-green-dark {
  color: $color-success-500 !important;
  background-color: $color-success-300 !important;
  border-color: $color-success-300 !important;
}

// PURPLE
.base-label-color-purple-inverted {
  color: $color-white !important;
  background-color: $color-purple-500 !important;
  border-color: $color-purple-500 !important;
}
.base-label-color-purple-light {
  color: $color-purple-500 !important;
  background-color: $color-purple-200 !important;
  border-color: $color-purple-200 !important;
}
.base-label-color-purple-dark {
  color: $color-purple-500 !important;
  background-color: $color-purple-300 !important;
  border-color: $color-purple-300 !important;
}

// GREY
.base-label-color-grey-inverted {
  color: $color-white !important;
  background-color: $color-grey-600 !important;
  border-color: $color-grey-600 !important;
}
.base-label-color-grey-light {
  color: $color-grey-600 !important;
  background-color: $color-grey-300 !important;
  border-color: $color-grey-300 !important;
}
.base-label-color-grey-dark {
  color: $color-grey-600 !important;
  background-color: $color-grey-400 !important;
  border-color: $color-grey-400 !important;
}
</style>
